import React from 'react'
import { Show, TextField, DateField } from '@refinedev/antd'
import { useShow, useOne } from '@refinedev/core'
import { Typography, Tag } from 'antd'
import type { Tables } from '@muaa/shared'

type Notification = Tables<'notifications'>
type Profile = Tables<'profiles'>

const { Title } = Typography

const GRP_COLORS: Record<string, string> = {
  Today: 'green',
  'This Week': 'blue',
  Earlier: 'default',
}

export function NotificationShow() {
  const { query } = useShow<Notification>()
  const isLoading = query.isLoading
  const record = query.data?.data

  // Resolve user_id -> profile name (mirrors donations/rsvps show pattern)
  const { query: profileQuery } = useOne<Profile>({
    resource: 'profiles',
    id: record?.user_id ?? '',
    meta: { idColumnName: 'user_id' },
    queryOptions: { enabled: !!record?.user_id },
  })

  return (
    <Show isLoading={isLoading}>
      <Title level={5}>Recipient</Title>
      <TextField
        value={
          profileQuery.data?.data?.name ??
          record?.user_id ??
          '—'
        }
      />

      <Title level={5}>Group</Title>
      {record?.grp ? (
        <Tag color={GRP_COLORS[record.grp] ?? 'default'}>{record.grp}</Tag>
      ) : (
        <TextField value="—" />
      )}

      <Title level={5}>Icon</Title>
      <TextField value={record?.icon ?? '—'} />

      <Title level={5}>Title</Title>
      <TextField value={record?.title ?? '—'} />

      <Title level={5}>Body</Title>
      <TextField value={record?.body ?? '—'} />

      <Title level={5}>Time</Title>
      <TextField value={record?.time ?? '—'} />

      <Title level={5}>Status</Title>
      <Tag color={record?.unread ? 'red' : 'default'}>
        {record?.unread ? 'Unread' : 'Read'}
      </Tag>

      <Title level={5}>Created</Title>
      {record?.created_at ? (
        <DateField value={record.created_at} format="MMM D, YYYY h:mm A" />
      ) : (
        <TextField value="—" />
      )}
    </Show>
  )
}
